import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import grayBg from 'assets/img/solid-bg-gray.png';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import {
  Button,
  Card,
  Carousel,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import InfoRealEstateModal from './InfoRealEstateModal';
import ReportModal from './ReportModal';
import SharePropModal from './SharePropModal';
import { TitleGenerator } from 'utils/TitleGenerator';
import { getImageUrl } from '../../../../../../../utils/imageUrl';

const CharacteristicItem = ({ icon, number, text }) => (
  <Col
    xs={3}
    md={2}
    className="d-flex flex-column align-items-center justify-content-center gap-2"
  >
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip className="tooltip-custom">
          <strong>{text}</strong>
        </Tooltip>
      }
    >
      <span
        className="d-flex justify-content-center align-items-center gap-2 ps-2"
        style={{ color: '#344050' }}
      >
        <p className="m-0">
          <strong>{number}</strong>
        </p>
        <FontAwesomeIcon icon={icon} />
      </span>
    </OverlayTrigger>
  </Col>
);

CharacteristicItem.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired
};

const SharedCard = ({
  prop,
  loading,
  noShareButton,
  noRounded,
  noShareModal,
  noShadow,
  noDenuncia,
  selected,
  setSelected
}) => {
  const [showControls, setShowControls] = useState(false);
  const [openInfoRealEstateModal, setOpenInfoRealEstateModal] = useState(false);
  const [propToShare, setPropToShare] = useState(null);
  const [propToReport, setPropToReport] = useState(null);

  const characteristics = [
    {
      icon: 'door-closed',
      number: prop?.characteristics?.ambience,
      text: prop?.characteristics?.ambience === 1 ? 'Ambiente' : 'Ambientes'
    },
    {
      icon: 'bed',
      number: prop?.characteristics?.bedrooms,
      text: prop?.characteristics?.bedrooms === 1 ? 'Dormitorio' : 'Dormitorios'
    },
    {
      icon: 'bath',
      number: prop?.characteristics?.bathrooms,
      text: prop?.characteristics?.bathrooms === 1 ? 'Baño' : 'Baños'
    },
    {
      icon: 'car',
      number: prop?.characteristics?.garages?.quantity,
      text:
        prop?.characteristics?.garages?.quantity === 1 ? 'Cochera' : 'Cocheras'
    }
  ];

  const handleLogoUrl = () => {
    if (prop.real_estate.logo) {
      // if (process.env.NEXT_PUBLIC_ENV === 'local') {
      //   return `http://localhost:9000/uploads/realestate/logos/12374/logo.png`;
      // }
      return prop.real_estate.logo.match(/http/)
        ? prop.real_estate.logo
        : getImageUrl(prop.real_estate.logo, 'realestate', '');
    }
    return 'assets/logos/noLogo.png';
  };

  const cardImage = image => {
    return (
      <>
        <Card.Img
          src={getImageUrl(image, 'properties', prop.id)}
          alt={prop.title}
          style={{
            aspectRatio: '16/9',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            objectFit: 'cover'
          }}
          className={classNames({
            'rounded-0': noRounded
          })}
        />
      </>
    );
  };

  const HandleCheckbox = () => {
    if (selected.find(property => property.id === prop.id)) {
      setSelected(selected.filter(property => property.id !== prop.id));
    } else {
      setSelected([
        ...selected,
        {
          id: prop.id,
          title: prop.title,
          status: prop.status,
          price: prop.price,
          ambiences: prop.characteristics.ambience,
          type: prop.type,
          real_estate: prop.real_estate,
          share: prop.share,
          neighborhood: prop.barrios
        }
      ]);
    }
  };

  return (
    <>
      <Card
        className={classNames('bg-white p-0 h-100', {
          'rounded-0': noRounded,
          'shadow-sm': noShadow
        })}
      >
        <div className="position-relative">
          <div
            className="position-absolute d-flex align-items-center justify-content-center"
            style={{
              zIndex: 2,
              background: '#fff',
              width: 30,
              height: 30,
              borderRadius: 5,
              top: 5,
              right: 5
            }}
          >
            <Form.Check
              type="checkbox"
              onChange={HandleCheckbox}
              name={prop.id}
              checked={
                selected
                  ? selected.find(property => property.id === prop.id)
                  : false
              }
            />
          </div>
          <Carousel
            interval={null}
            onMouseEnter={() => setShowControls(true)}
            onMouseLeave={() => setShowControls(false)}
            controls={showControls && prop.images.length > 1}
            indicators={showControls}
            className="theme-slider"
            nextIcon={
              <FontAwesomeIcon
                icon="circle-arrow-right"
                size="2xl"
                className="border-icon"
              />
            }
            prevIcon={
              <FontAwesomeIcon
                icon="circle-arrow-left"
                size="2xl"
                className="border-icon"
              />
            }
          >
            {!prop?.images ? (
              <Carousel.Item>
                <Card.Img
                  src={grayBg}
                  alt={prop?.title}
                  style={{
                    aspectRatio: '16/9',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    objectFit: 'cover'
                  }}
                  className={classNames({
                    'rounded-0': noRounded
                  })}
                />
              </Carousel.Item>
            ) : (
              prop?.images.map((image, index) => (
                <Carousel.Item
                  key={`${image.url || `${image.filename}`}-${index}`}
                >
                  {cardImage(image)}
                </Carousel.Item>
              ))
            )}
          </Carousel>

          {prop?.real_estate && (
            <img
              src={handleLogoUrl() || grayBg}
              className="real-estate-logo"
              onClick={() => setOpenInfoRealEstateModal(true)}
            />
          )}
        </div>

        <Card.Header>
          <Card.Subtitle className="mb-2 d-flex align-items-center">
            {/* <Form.Check
              type="checkbox"
              onChange={HandleCheckbox}
              name={prop.id}
              checked={selected.find(prop => prop.id === prop.id) || false}
              style={{ marginBottom: '0.25em' }}
            /> */}
            <p className="m-0 text-muted">
              {prop?.operation} - {prop.type}
            </p>
          </Card.Subtitle>
          <Card.Title>{prop.title}</Card.Title>
          <Card.Text>
            {prop?.address}, <strong>{prop?.barrios}</strong>, CABA
          </Card.Text>
        </Card.Header>

        <Card.Body className="py-1">
          <div className="d-flex flex-column justify-content-end h-100">
            <div className="d-flex flex-wrap gap-2 justify-content-start">
              {![4, 9, 10, 13].includes(prop?.property_type) &&
                characteristics.map((characteristic, index) =>
                  characteristic.number ? (
                    <CharacteristicItem
                      key={index}
                      icon={characteristic.icon}
                      text={characteristic.text}
                      number={characteristic.number}
                    />
                  ) : null
                )}

              {!!prop?.surface?.coveredSurface && (
                <CharacteristicItem
                  icon="arrows-left-right-to-line"
                  number={prop?.surface.coveredSurface}
                  text="Superficie Cubierta en m²"
                />
              )}
              {!!prop?.surface?.totalSurface && (
                <CharacteristicItem
                  icon="ruler-combined"
                  number={prop?.surface?.totalSurface}
                  text="Superficie Total en m²"
                />
              )}
            </div>

            <p className="m-0 mt-3 small">Publicado el {prop.created_at}</p>
          </div>
        </Card.Body>

        <style>
          @media (max-width: 575.98px){' '}
          {`
              .d-flex.gap-2.justify-content-start.justify-content-sm-between > div {
                  flex-basis: calc(50% - 1rem); /* 1rem es aproximadamente el tamaño del gap, ajústalo según tus necesidades */
                  max-width: calc(50% - 1rem);
              }
            `}
        </style>

        <Card.Footer className="border-top">
          <Row>
            <Col xs={12} sm={8} md={7}>
              <p
                className={classNames('m-0 fw-bold fs-1', { 'mb-1': loading })}
              >
                {prop?.price}
              </p>
              {/\d/.test(prop?.expenses) ? (
                prop?.expenses.toString().trim() !== '0' ? (
                  <p className="m-0 fs--1">Expensas: {prop?.expenses}</p>
                ) : (
                  <p className="m-0 fs--1">Sin expensas</p>
                )
              ) : (
                <p className="m-0 fs--1">Sin expensas</p>
              )}
            </Col>

            {!noShareButton && prop?.share?.percent && (
              <Col
                xs={12}
                sm={4}
                md={5}
                lg={5}
                className="text-end d-flex align-items-center justify-content-end"
              >
                <p
                  className={classNames('m-0 fs--1', {
                    'mb-1': loading
                  })}
                >
                  Honorarios:&nbsp;
                </p>
                <p className="m-0 fw-bold fs-1">{prop?.share?.percent}%</p>
              </Col>
            )}
          </Row>

          <div className="mt-3 d-flex flex-column gap-2 w-100 mt-sm-4 mt-lg-2">
            {!noShareButton && (
              <Button
                className="w-100 w-sm-auto"
                style={{ flexGrow: 1 }}
                size="sm"
                onClick={() => setPropToShare(prop)}
              >
                Compartir
              </Button>
            )}
            <Button
              className="w-100 w-sm-auto"
              style={{ flexGrow: 1 }}
              size="sm"
              key={`view-${prop._id}`}
              onClick={() =>
                window.open(
                  `${process.env.REACT_APP_CLIENT_DETAIL}${
                    prop.id
                  }/${TitleGenerator(prop.title)}`,
                  '_blank'
                )
              }
              tooltipText="Ver en CabaProp"
              tooltipPosition="left"
              variant="secondary"
            >
              Ver en Cabaprop
            </Button>
          </div>
        </Card.Footer>
      </Card>

      {prop?.real_estate && (
        <InfoRealEstateModal
          show={openInfoRealEstateModal}
          setShow={setOpenInfoRealEstateModal}
          realEstate={prop?.real_estate}
          branchOffice={prop?.branch_office}
        />
      )}

      {!noShareModal && (
        <SharePropModal
          propToShare={propToShare}
          setPropToShare={setPropToShare}
        />
      )}

      {!noDenuncia && propToReport && (
        <ReportModal
          propToReport={propToReport}
          setPropToReport={setPropToReport}
        />
      )}
    </>
  );
};

SharedCard.propTypes = {
  prop: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  noShareButton: PropTypes.bool,
  noRounded: PropTypes.bool,
  noShareModal: PropTypes.bool,
  noShadow: PropTypes.bool,
  noSharedPercent: PropTypes.bool,
  noDenuncia: PropTypes.bool,
  selected: PropTypes.array,
  setSelected: PropTypes.func
};

export default SharedCard;
